import { incident_activities } from './incident_activities';
import { load_incidents } from './load_incidents';

export const resources = [
    load_incidents,
    incident_activities
];
